import { render, staticRenderFns } from "./ContactNetworkItem.vue?vue&type=template&id=5febb644&scoped=true&"
import script from "./ContactNetworkItem.vue?vue&type=script&lang=js&"
export * from "./ContactNetworkItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactNetworkItem.vue?vue&type=style&index=0&id=5febb644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5febb644",
  null
  
)

export default component.exports